/**
 * mobile-section-tabs.tsx — Thay menu phụ bên trái (SectionSubnav) trên điện thoại: một hàng chip cuộn ngang ở đầu trang
 * cho các trang con của mục (Khách hàng, Báo cáo…), kiểu thanh phân loại của Lark Mobile. Chip đang chọn tự cuộn vào giữa.
 */
import { useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { activeLeaf, activeSubLeaf, type NavItem, type NavLeaf } from './nav-config'
import { cn } from '@/lib/utils'

export function MobileSectionTabs({ item }: { item: NavItem }) {
  const { pathname } = useLocation()
  // Chip phẳng một hàng: trang cấp 2 có menu con cấp 3 thì hiện thẳng các trang con của nó.
  const leaves: NavLeaf[] = (item.children ?? []).flatMap((c) => c.children ?? [c])
  const top = activeLeaf(item, pathname)
  const current = top?.children ? activeSubLeaf(top, pathname) : top
  const activeRef = useRef<HTMLAnchorElement | null>(null)
  useEffect(() => {
    activeRef.current?.scrollIntoView?.({ inline: 'center', block: 'nearest' })
  }, [current?.to])

  return (
    <nav aria-label={item.label} className="shrink-0 border-b bg-background">
      <ul className="flex gap-2 overflow-x-auto px-4 py-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {leaves.map((leaf) => {
          const active = current?.to === leaf.to
          return (
            <li key={leaf.to} className="shrink-0">
              <Link
                ref={active ? activeRef : undefined}
                to={leaf.to}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'inline-flex h-8 items-center rounded-full px-3.5 text-sm transition-colors',
                  active ? 'bg-primary font-medium text-primary-foreground' : 'bg-muted text-muted-foreground active:bg-muted/70',
                )}
              >
                {leaf.label}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
